<template>
    <div class="l-page  page">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-page'
    }
</script>


// WEBPACK FOOTER //
// src/components/Page.vue